import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { IUser } from 'src/app/shared/models/auth.model';
import {
  INotify,
  INotifyItem,
  NotificationTypeEnum,
  NotifyIconMapper,
  NotifyMapper,
} from 'src/app/shared/models/notifications.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import * as moment from 'moment';
import {TranslocoService} from '@ngneat/transloco';

@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  NotifyMapper = NotifyMapper;
  NotifyIconMapper = NotifyIconMapper;
  NotificationTypeEnum = NotificationTypeEnum;

  @Output()
  toggleMenu = new EventEmitter<void>();

  fullName?: string = '';
  visibleNotify = false;
  notifyList: INotifyItem[] = [];
  notifyCount = 0;

  curTime = moment();
  intervalId: any;

  constructor(
    public authService: AuthService,
    private socketService: SocketService,
    private notificationsService: NotificationsService,
    private router: Router,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.curTime = moment(), 60000);
    this.getUserName();
    this.trackNotify();
    this.getNotify();
  }

  ngOnDestroy() {
    if (!this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getUserName(): void {
    this.authService.authUser.subscribe((user: IUser | undefined) => {
      this.fullName = '';
      if (user?.lastName) {
        this.fullName += user?.lastName;
      }
      if (user?.midleName) {
        this.fullName += ' ' + user?.midleName;
      }
      if (user?.firstName) {
        this.fullName += ' ' + user?.firstName;
      }
      this.fullName = this.fullName || user?.email;
    });
  }

  logout(): void {
    this.authService.logout();
  }

  trackNotify(): void {
    this.socketService.eventsData$.subscribe(() => {
      this.notifyCount++;
    });
  }

  getNotify(): void {
    this.notificationsService
      .getNotifications({ page: 1, limit: 50 })
      .subscribe((data: INotify) => {
        this.handleGetNotify(data);
      });
  }

  handleGetNotify(data: INotify): void {
    this.notifyList = data.items.map((ele) => ({
      ...ele,
      message: this.translocoService.translate(NotifyMapper[ele.type]),
      notifyIcon: NotifyIconMapper[ele.type],
   }));
   this.notifyCount = data.totalNew;
  }

  updateLastSeen(): void {
    this.getNotify();
    this.notificationsService
      .updateLastSeen()
      .pipe(
        switchMap(() => this.notificationsService.getNotifications({ page: 1, limit: 50 }))
      )
      .subscribe((data: INotify) => {
        this.handleGetNotify(data);
      });
  }

  detailNotify(notifyType: NotificationTypeEnum, notifyId: string, seen: boolean) {
    switch (notifyType) {
      case NotificationTypeEnum.HOMEWORKCONFIRMED:
      case NotificationTypeEnum.HOMEWORKANSWERED:
      case NotificationTypeEnum.HOMEWORKREJECTED:
        this.router.navigate(['/study/homework'], { queryParams: { tab: 2} });
        break;
      default:
        break;
    }
    this.visibleNotify = false;
    if (!seen) {
      this.updateSeen(notifyId);
    }
  }

  updateSeen(notifyId: string): void {
    this.notificationsService.updateSeen(notifyId).subscribe(() => {
      this.notifyCount--;
    });
  }
}
